module.exports = __webpack_public_path__ + "img/ROP.5c9da518.svg";